export default function ({ className }) {
  return (
    <svg
      width='99'
      height='94'
      viewBox='0 0 99 94'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M37.6691 35.8524H37.71M59.3699 37.0195L38.8974 56.4706M60.1888 57.6377H60.2297M11.0549 40.1317C10.1375 41.0024 9.40977 42.0364 8.91324 43.1745C8.4167 44.3126 8.16113 45.5325 8.16113 46.7645C8.16113 47.9965 8.4167 49.2164 8.91324 50.3546C9.40977 51.4927 10.1375 52.5266 11.0549 53.3973L42.1321 82.9241C43.0485 83.7957 44.1368 84.4872 45.3346 84.959C46.5325 85.4307 47.8165 85.6735 49.1132 85.6735C50.4099 85.6735 51.6938 85.4307 52.8917 84.959C54.0896 84.4872 55.1778 83.7957 56.0943 82.9241L87.1714 53.3973C88.0888 52.5266 88.8166 51.4927 89.3131 50.3546C89.8096 49.2164 90.0652 47.9965 90.0652 46.7645C90.0652 45.5325 89.8096 44.3126 89.3131 43.1745C88.8166 42.0364 88.0888 41.0024 87.1714 40.1317L56.0943 10.6049C55.1778 9.73326 54.0896 9.04181 52.8917 8.57005C51.6938 8.09829 50.4099 7.85547 49.1132 7.85547C47.8165 7.85547 46.5325 8.09829 45.3346 8.57005C44.1368 9.04181 43.0485 9.73326 42.1321 10.6049L11.0549 40.1317Z'
        stroke='#3A3A3A'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
